import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'ck-ui';
import { useCountdown } from 'ck-utils/hooks';
import styles from './DropTimer.module.scss';

const DropTimer = ({
  dropsIn,
  callOut,
}) => {
  const countdown = useCountdown({ targetDateString: dropsIn });

  if (!countdown) return null;

  const { days, hours, minutes, seconds } = countdown;

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <Typography display="block" variant="body-medium" className={styles.dropInContent} color="white" weight={700}>
          {callOut}
        </Typography>
        <Typography className={styles.content} color="white" weight={700}>
          {days}d &nbsp;{hours}h &nbsp;{minutes}m &nbsp;{seconds}s
        </Typography>
      </div>
    </div>
  );
};

DropTimer.propTypes = {
  dropsIn: PropTypes.string.isRequired,
  callOut: PropTypes.node
};

DropTimer.defaultProps = {
  callOut: 'Drops In:'
};

export { DropTimer };
